<template>
    <!-- 附件 弹框 -->
    <el-dialog
            :closeOnClickModal='false'
            class="attachment receiptSignattachment"
            title="附件预览"
            v-drag
            :visible="true"
            :before-close="beforeClose"
            width="60%"
            append-to-body>
        <div class="attachmentLeft">
            <div style="height: 500px;">
                <div class="img-item" style="display: none;" id="viewers">
                    <ul>
                        <li v-for="(item, index) in imgArr"
                            :key="index">
                            <img :src="item" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
/**
 * 功能: 1.支持图片、office文件预览，不支持exe、dll等不可预览格式文件的预览
 *      2.预览弹窗支持拖拽
 *      3.支持多图片预览
 * @param rowData {Object}
 * @param attachmentList {Array} 这是必要参数 例:['http://1.jpg', 'http://2.png'], 单文件预览时传空数组
 * @param rowData.downUrl {String} 这是必要参数
 * @param rowData.fileId  {String}
 * @param rowData.fileName {String}
 * **/
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { urlToFilePreviewFrom } from '../utils/urlToFilePreviewFrom.js';
import { filePreview } from '@/utils/filePreview.js';
const imagesReg = /\.(jpg|bmp|gif|ico|pcx|jpeg|png|raw|tga)$/;
const officeReg = /\.(doc|docx|xls|xlsx|ppt|pptx|pdf|txt|tif)$/;
const ossFileUrlReg = /\.(jpg|bmp|gif|ico|pcx|jpeg|png|raw|tga)\?certification=\w+/;
export default {
    props: {
        attachmentShow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        },
        certification: {
            type: String,
            default() {
                return '';
            }
        },
        attachmentList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            updateTime: '',
            updateUserName: '',
            imgArr: [],
            allImgArr: [],
            allImgArr_: [],
            currentIndex: 0,
            listIndex: 0,
            maxPcs: 20,
            viewer: {}
        };
    },
    methods: {
        beforeClose() {
            this.$emit('update:attachmentShow', false);
        },
        initViewerOfMore() {
            const barOptions = { show: true, size: 'normal' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: false,
                button: true,
                keyboard: true,
                prev: this.imgArr.length,
                next: this.imgArr.length,
                zoomRatio: 0.2,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: () => {
                        if (this.listIndex > 0) {
                            this.listIndex -= 1;
                            this.viewer.view(this.listIndex);
                        } else {
                            if (this.currentIndex <= this.maxPcs - 1) {
                                const oldIndex = this.currentIndex;
                                this.currentIndex = 0;
                                this.imgArr = this.allImgArr.splice(this.currentIndex, oldIndex);
                                this.imgArr = this.handleReplaceSpace(this.imgArr);
                                this.restoreAllImgArr();
                            } else {
                                this.currentIndex -= this.maxPcs;
                                this.imgArr = this.allImgArr.splice(this.currentIndex, this.maxPcs);
                                this.imgArr = this.handleReplaceSpace(this.imgArr);
                                this.restoreAllImgArr();
                            }
                            this.listIndex = this.imgArr.length - 1;
                            this.$nextTick(() => {
                                this.viewer.update();
                                this.viewer.view(this.listIndex);
                            });
                        }
                    },
                    next: () => {
                        if (this.listIndex < this.imgArr.length - 1) {
                            this.listIndex += 1;
                            this.viewer.view(this.listIndex);
                        } else {
                            if (this.allImgArr.length - 1 - this.currentIndex >= this.maxPcs) {
                                const num = this.maxPcs > this.imgArr.length ? this.imgArr.length : this.maxPcs;
                                this.currentIndex += num;
                                this.imgArr = this.allImgArr.splice(this.currentIndex, this.maxPcs);
                                this.imgArr = this.handleReplaceSpace(this.imgArr);
                                this.restoreAllImgArr();
                                this.listIndex = 0;
                            } else {
                                if (this.listIndex === this.imgArr.length - 1) return;
                                const oldIndex = this.currentIndex;
                                this.currentIndex += this.allImgArr.length - 1;
                                this.imgArr = this.allImgArr.splice(oldIndex, this.allImgArr.length - 1 - oldIndex);
                                this.imgArr = this.handleReplaceSpace(this.imgArr);
                                this.restoreAllImgArr();
                                this.listIndex = 0;
                            }
                            this.$nextTick(() => {
                                this.viewer.update();
                                this.viewer.view(this.listIndex);
                            });
                        }
                    },
                    reset: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        initViewer() {
            const barOptions = { show: true, size: 'normal' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: false,
                button: true,
                keyboard: true,
                prev: this.imgArr.length,
                next: this.imgArr.length,
                zoomRatio: 0.2,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: barOptions,
                    next: barOptions,
                    reset: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        getImgList() {
            // this.updateTime = this.rowData.updateTime;
            // this.updateUserName = this.rowData.updateUserName;
            // this.imgSrc = this.rowData.downUrl;
            if (!this.attachmentList.length) {
                // 单图片预览，attachmentList传空
                this.imgArr = [].concat(this.rowData.downUrl);
                this.imgArr = this.handleReplaceSpace(this.imgArr);
                this.$nextTick(() => {
                    this.initViewer();
                });
            } else {
                // 多图片预览
                this.imgArr = this.attachmentList.filter((item) => imagesReg.test(item.toLowerCase()) || ossFileUrlReg.test(item.toLowerCase()));
                if (this.imgArr.length < this.maxPcs) {
                    const list = this.imgArr.splice(this.imgArr.indexOf(this.rowData.downUrl));
                    this.imgArr = list.concat(this.imgArr);
                    this.imgArr = this.handleReplaceSpace(this.imgArr);
                    this.$nextTick(() => {
                        this.initViewer();
                    });
                } else {
                    // 多于 maxPcs 张图片时
                    this.allImgArr = JSON.parse(JSON.stringify(this.imgArr));
                    this.allImgArr_ = JSON.parse(JSON.stringify(this.allImgArr));
                    this.currentIndex = this.allImgArr.indexOf(this.rowData.downUrl);
                    this.imgArr = this.allImgArr.splice(this.currentIndex, this.maxPcs);
                    this.imgArr = this.handleReplaceSpace(this.imgArr);
                    this.restoreAllImgArr();
                    this.$nextTick(() => {
                        this.initViewerOfMore();
                    });
                }
            }
        },
        restoreAllImgArr() {
            this.allImgArr = JSON.parse(JSON.stringify(this.allImgArr_));
        },
        // 防止旧数据的图片路径含有空格, 去除空格
        handleReplaceSpace(imgArr) {
            imgArr.map((item) => {
                item.replace(/\s+/g, '');
            });
            return imgArr;
        }
    },
    mounted() {
        const fileType = this.rowData.downUrl.slice(this.rowData.downUrl.lastIndexOf('.'));
        if (imagesReg.test(fileType.toLowerCase()) || ossFileUrlReg.test(fileType.toLowerCase())) {
            this.getImgList();
            return;
        }
        if (officeReg.test(fileType.toLowerCase())) {
            const fileUrl = this.rowData.downUrl.replace(/^https/, 'http');
            // const form = {
            // fileName: this.rowData.fileName || '',
            // fileId: this.rowData.fileId || '',
            // fileUrl: fileUrl
            // };
            const form = urlToFilePreviewFrom(fileUrl);
            filePreview(form);
            this.$emit('update:attachmentShow', false);
            return;
        }
        this.$emit('update:attachmentShow', false);
        this.$message.warning('该文件格式不支持预览');
    }
};
</script>
<style lang="less">
    .attachment {
        .attachmentTitle {
            margin: 10px 0;
            font-size: 14px;
        }
        .attachmentLeft {
            .img-item {
                width: 98%;
                height: 96%;
            }
        }
    }
</style>